export const CLIPBOARD = "CLIPBOARD";
export const COPY = "COPY";
export const ENTER = "ENTER";
export const DEFAULT = "DEFAULT";

export type AlertType = typeof CLIPBOARD | typeof COPY | typeof ENTER | typeof DEFAULT;